import { environment, urls } from 'Config'

import { useFeatureFlags } from '@/providers/featureFlags/FeatureFlagsProvider'
import useFeatureFlagsReady from '@/hooks/useFeatureFlagsReady'
import { FEATURE_FLAG_KEYS } from '@/constants'

const env = (() => {
  switch (true) {
    case environment.startsWith('sandbox'):
      return 'sandbox'
    case environment.startsWith('production'):
      return 'production'
    default:
      return 'test'
  }
})()

// The flag value ends up as an iframe `src`, so only an absolute https URL is accepted -
// anything else (typo, `javascript:` URL) falls back to the build-time base URL.
const isHttpsUrl = value => {
  try {
    return new URL(value).protocol === 'https:'
  } catch {
    return false
  }
}

const MarketingIframe = () => {
  const featureFlags = useFeatureFlags()
  const isFlagsReady = useFeatureFlagsReady()
  const flagUrl = featureFlags[FEATURE_FLAG_KEYS.LOGIN_MARKETING_IFRAME_URL]
  const baseUrl = isHttpsUrl(flagUrl) ? flagUrl : urls.marketingIframe

  // Held back until the flag has resolved, so the iframe does not load the fallback URL
  // first and then reload with the flag value.
  return (
    <div className="login-iframe">
      {isFlagsReady && (
        <iframe className="responsive-iframe" title="ZenQMS customer resources" src={`${baseUrl}${env}`}></iframe>
      )}
    </div>
  )
}

export default MarketingIframe
